import axios from 'axios'
import { EnumResponse } from '@/api/services/common.dto'

class CaseValidationSituationConfigurationService {
    async getCaseValidationSituations(): Promise<EnumResponse[]> {
        const response = await axios.get(`/configuration/caseValidationSituations`)
        return response.data
    }

    async getCustomNotificationTypes(): Promise<EnumResponse[]> {
        const response = await axios.get(`/configuration/customNotificationTypes`)
        return response.data
    }
}

export const caseValidationSituationConfigurationService = new CaseValidationSituationConfigurationService()
